import Tr from 'translations/Translations';

const createItem = (value) => ({label: Tr('caseClassificationSymbol.' + value), value})

export default [
    {label: '---', value: ''},
    createItem('270'),
    createItem('271'),
    createItem('272')
]